import { FC } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { Navigate } from 'react-router-dom';
import { ACCESS_TOKEN_KEY } from '../../constants/config.ts';
import { Children } from '../../constants/types/prop.types.ts';
import withMe, { MePropsType } from '../../hocs/withMe.tsx';
import Routes from '../routes.enum.ts';
import { UserRoles } from '../../constants/entities.ts';
import BlockedAgencyGuard from './BlockedAgencyGuard.tsx';

/**
 * Guard that redirects authenticated users away from sign-in pages
 * to their appropriate dashboard based on role
 */

// Component that handles redirect logic for authenticated users
const AuthenticatedUserRedirect = withMe(({ user }: MePropsType) => {
  // Check if user has Admin role
  if (user?.role === UserRoles.Admin) {
    return <Navigate to={Routes.AdminDashboard} replace />;
  }
  return <Navigate to={Routes.Dashboard} replace />;
});

const SignInRedirectGuard: FC<Children> = ({ children }) => {
  const [accessToken] = useLocalStorage(ACCESS_TOKEN_KEY, '');

  // If user has access token, redirect them to appropriate dashboard
  if (accessToken) {
    return <BlockedAgencyGuard><AuthenticatedUserRedirect /></BlockedAgencyGuard>;
  }

  // If no access token, allow access to sign-in page
  return children;
};

export default SignInRedirectGuard;
